// extracted by mini-css-extract-plugin
module.exports = {"video-item":"video-item","videoItem":"video-item"};